import { postAppGraphql } from "./appGraphqlService";

const WRITE_EVENT_LOG_MUTATION = `
  mutation WriteEventLog($input: WriteEventLogInput!) {
    writeEventLog(input: $input) {
      success
      message
    }
  }
`;

export type WriteEventLogResult = {
  success: boolean;
  message: string;
};

type WriteEventLogResponse = {
  writeEventLog?: WriteEventLogResult | null;
};

type PostWriteEventLogParams = {
  token: string;
  topic: string;
  message: Record<string, unknown>;
  messageTimestamp?: Date;
};

export async function postWriteEventLog({
  token,
  topic,
  message,
  messageTimestamp,
}: PostWriteEventLogParams): Promise<WriteEventLogResult> {
  const timestamp = messageTimestamp ?? new Date();
  const payload = await postAppGraphql<WriteEventLogResponse>({
    token,
    operationName: "WriteEventLog",
    query: WRITE_EVENT_LOG_MUTATION,
    keepalive: true,
    variables: {
      input: {
        topic,
        message: JSON.stringify(message),
        messageAttributes: JSON.stringify({}),
        messageTimestamp: timestamp.toISOString(),
      },
    },
  });

  const result = payload.data?.writeEventLog;
  if (!result) {
    throw new Error("Event log response was empty.");
  }
  if (!result.success) {
    throw new Error(result.message || "Failed to write event log.");
  }

  return result;
}
